/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseTemplateDtoPage } from '../../models/base-template-dto-page';

export interface ListTemplates$Params {
  projectId?: string | null;
  query?: string;
  assigneeId?: string | null;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  groupsIds?: Array<string>;
  dynamicFilters?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<string>;
}

export function listTemplates(http: HttpClient, rootUrl: string, params?: ListTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listTemplates.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('query', params.query, {});
    rb.query('assigneeId', params.assigneeId, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('groupsIds', params.groupsIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseTemplateDtoPage>;
    })
  );
}

listTemplates.PATH = '/v0/templates';
